import 'ric'
import 'whatwg-fetch'
import 'url-search-params-polyfill'

const fromEntries = require('object.fromentries')
if (!Object.fromEntries) {
  fromEntries.shim()
}
